export const environment = {
    production: true,
    //SCHEDULE_DOMAIN: 'https://dev-cloud.fastgo.mobi:31508',
    //OTP_DOMAIN: 'https://dev-cloud.fastgo.mobi:31004'

    // build_production.bat
    SCHEDULE_DOMAIN: 'https://vn-cloud.fastgo.mobi:30508',
    OTP_DOMAIN: 'https://xx-cloud.fastgo.mobi:30004'
};
